export const getError = state => state.manageDevices.get('error')
export const getIsSubmitting = state => state.manageDevices.get('isSubmitting')
